import { Currency, TaxLabel } from "~/gql/graphql";

export const TAX_LABEL_VALUES = ["VAT", "GST"];

export type ICurrency = Pick<Currency, "id" | "name" | "symbol" | "code">;

export interface Settings {
  id: number;
  gpmDangerThreshold: number;
  gpmWarningThreshold: number | null;
  organisationPmsName: string | null;
  taxLevelPercent: number | null;
  taxLabel: TaxLabel;
  currency: ICurrency;
  restrictGpmVisibility: boolean;
  showGpmSlider: boolean;
  enableAi: boolean;
  enableTechPricing: boolean;
  enableWordExport: boolean;
  administrationCharge: number;
  decimalTimeInput: boolean;
  systemFont: string;
  autoCloseIntervalInDays: number;
}
